<template>
  <div class="NoticeCom">
    {{ propValue }}
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: { },
  props: {
    propValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem
    })
  },

  created() {
    console.log(this.propValue)
  },

  methods: {}
}
</script>

<style lang="scss" scoped>
.ProjectPersonCom {
  width: 300px;
  height: 240px;
  color: #fff;

  .top{
    background: linear-gradient(135deg, transparent 10px, #042068 0) top left,
                linear-gradient(-135deg, transparent 10px, #042068 0) top right,
                linear-gradient(-45deg, transparent 10px, #042068 0) bottom right,
                linear-gradient(45deg, transparent 10px, #042068 0) bottom left;
    background-size: 50% 50%;
    background-repeat: no-repeat;
    height: 100px;
    text-align: center;
    padding-top: 10px;

    color: #ffff00;
    .projectCountDesc{
      font-size: 16px;
    }
    .projectCountNum{
      font-size: 50px;
      margin-top: 10px;
    }

  }
  .bottom{
    background: linear-gradient(135deg, transparent 10px, #042068 0) top left,
                linear-gradient(-135deg, transparent 10px, #042068 0) top right,
                linear-gradient(-45deg, transparent 10px, #042068 0) bottom right,
                linear-gradient(45deg, transparent 10px, #042068 0) bottom left;
    background-size: 50% 50%;
    background-repeat: no-repeat;
    height: 110px;
    display: flex;
    .itemWrapping{
      flex: 1;
      display: flex;
      padding-top: 20px;
      .item{
        text-align: center;
        flex: 1;
        .desc{
          font-size: 15px;
        }
        .num{
          font-size: 30px;
          margin-top: 16px;
        }
        &:first-child{
          color: #00ff36;
          .desc{
            position: relative;
            &::after{
              width: 2px;
              height: 100%;
              position: absolute;
              content: "";
              right: 0;
              top: 0;
              background: #fff;
            }
          }
          .num{
            position: relative;
            &::after{
              width: 2px;
              height: 100%;
              position: absolute;
              content: "";
              right: 0;
              top: 0;
              background: #fff;
            }
          }
        }
        &:last-child{
          color: #0099ff;
        }
      }
    }
  }

}
</style>
